import { createAsyncThunk } from "@reduxjs/toolkit";
import ThunkExtraArguments from "../../types/ThunkExtraArguements";
import { RootState } from "../store";
import {
  ConfirmModalProps,
  confirmModalActions,
} from "store/confirmModalSlice";

const confirmModalThunkActions = {
  open: createAsyncThunk<
    boolean,
    ConfirmModalProps,
    {
      extra: ThunkExtraArguments;
    }
  >("confirmModal", async (confirmModalProps, { extra, dispatch }) => {
    const store = extra.store;

    dispatch(confirmModalActions.open(confirmModalProps));

    return new Promise<boolean>((resolve) => {
      const unsubscribe = store.subscribe(() => {
        const state: RootState = store.getState();
        if (state.confirmModal.isConfirmed) {
          unsubscribe();
          resolve(true);
        }
        if (state.confirmModal.isDeclined) {
          unsubscribe();
          resolve(false);
        }
      });
    });
  }),
};

export default confirmModalThunkActions;
